/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
// import { AnimationOnScroll } from 'react-animation-on-scroll';
// import 'animate.css/animate.min.css';

/* Component Imports */
import { Typography } from "@material-ui/core";

/* Data Imports */
import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 1rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 1rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 1rem 72rem",
    },
  },
  mainContainer: {
    // padding: "0rem 8rem 0rem 8rem",
    padding: "0rem 8rem 2rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
    width: "100%",
    margin: "2rem 0rem 0rem 0rem",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%",
  },
  heading: {
    width: "100%",
    margin: "0rem 0rem 0.5rem 0rem",
    fontWeight: 400,
    color: "#0DB14B",
    // background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    // WebkitBackgroundClip: "text",
    // WebkitTextFillColor: "transparent",
    fontSize: "2.5rem",
    lineHeight: "3rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.75rem",
      lineHeight: "2.125rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.75rem",
      lineHeight: "2.125rem",
    },
  },
  subHeading: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#202020",
    fontWeight: 400,
    fontSize: "1.125rem",
    lineHeight: "2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      lineHeight: "1.625rem",
    },
  },
  animation: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    margin: "2rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      // margin: "0rem 0rem 3rem 0rem",
      display: "none",
    },
  },
  animationmobile: {
    width: "100%",
    margin: "2.5rem 0rem 0.3rem 0rem",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  illustrationSizer: {
    objectFit: "contain",
    objectPosition: "center",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "280px",
      width: "280px",
    },
    [theme.breakpoints.only("xs")]: {
      height: "320px",
      width: "360px",
    },
    [theme.breakpoints.only("sm")]: {
      height: "600px",
      width: "700px",
    },
    [theme.breakpoints.only("md")]: {
      height: "800px",
      width: "900px",
    },
    [theme.breakpoints.only("lg")]: {
      height: "800px",
      // width: '1400px',
    },
    [theme.breakpoints.only("xl")]: {
      height: "800px",
      width: "1200px",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "850px",
      width: "1400px",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      height: "850px",
      width: "1400px",
    },
  },
  illustrationSizerMobile: {
    objectFit: "contain",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "auto",
      width: "100%",
    },
    [theme.breakpoints.only("xs")]: {
      height: "auto",
      width: "100%",
    },
  },
}));

const SectionThree = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <div className={classes.text}>
            <Typography
              variant="h1"
              component="h1"
              className={classes.heading}
            >
              Core Principles
            </Typography>
            <Typography
              variant="body2"
              component="span"
              className={classes.subHeading}
            >
              SENTIENT strongly strives to balance the five elements of nature in every space it works on. The five
              elements of nature are earth, fire, wind, water and space. Each of these elements has a subtle frequency
              that influences every living and non-living being on this planet. Our anatomy and life itself are
              dependent on the sensitive equilibrium of these five elements.
            </Typography>
          </div>
        </div>
        {/* <AnimationOnScroll animateIn="animate__fadeIn" duration={2}> */}
        <div className={classes.animation}>
          <img
            src="/images/icons/heavie/aboutus/chakra_new.svg"
            alt={AppConfig.imageAltText}
            width={1088}
            height={738}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
          />
        </div>
        <div className={classes.animationmobile}>
          <img
            src="/images/icons/heavie/aboutus/chakramobile_new.svg"
            alt={AppConfig.imageAltText}
            width={411}
            height={753}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizerMobile}
          />
        </div>
        {/* </AnimationOnScroll> */}
      </div>
    </React.Fragment>
  );
};

export default SectionThree;
